import { Trans } from '@lingui/react/macro';
import { Spinner } from 'components/Spinner/Spinner';
import styles from './OffersLoader.module.css';

export const OffersLoader = () => {
  return (
    <div className={styles.loaderContainer}>
      <h2 className={styles.heading}>
        <Trans>We’re checking your application...</Trans>
      </h2>
      <p className={styles.text}>
        <Trans>This may take up to 60 seconds</Trans>
      </p>
      <Spinner />
    </div>
  );
};
